<template>
	<div v-if="this.type == 'list'">
		<v-list-group v-model="selected">
			<v-list>
				<v-list-item v-for="item in list" :key="item.key" :value="item.key">
					<v-list-item-media>
						<flag :iso="item.region" v-bind:squared="false" />
					</v-list-item-media>

					<v-list-item-title v-text="item.name"></v-list-item-title>
				</v-list-item>
			</v-list>
		</v-list-group>
	</div>
	<div v-else-if="type == 'select'">
		<v-select
			v-model="selected"
			:items="list"
			:label="label"
			item-title="region"
			item-value="key"
			:readonly="readonly"
			:disabled="readonly"
			variant="underlined"
			color="primary"
		>
			<template v-slot:selection="{ item }">
				<div class="selection-item">
					<flag :iso="item.title" v-bind:squared="false" />
					{{ item.raw.name }}
				</div>
			</template>
			<template v-slot:item="{ item, props }">
				<div v-bind="props" class="selection-item">
					<flag :iso="item.title" v-bind:squared="false" />
					{{ item.raw.name }}
				</div>
			</template>
		</v-select>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: String,
			default: null,
		},
		type: {
			type: String,
			default: 'select',
		},
		list: {
			type: Array,
			default: () => [],
		},
		label: {
			type: String,
			default: '',
		},
		readonly: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			content: this.value,
		};
	},
	computed: {
		selected: {
			get() {
				return this.content;
			},
			set(value) {
				this.$emit('input', value);
				this.content = value;
			},
		},
	},
};
</script>

<style scoped>
.flag-icon {
	margin-right: 5px;
}
.selection-item {
	display: flex;
	align-items: center;
	padding: 0.5rem;
	gap: 0.25rem;
	cursor: pointer;
}
</style>
